// Intake API base URL. Production only; staging and local get null, which hides every intake surface.
export const INTAKE_API_URL = typeof window !== "undefined" && window.location.origin === "https://ops.sawtoothadvisors.io"
  ? "https://sawtooth-intake-functions.azurewebsites.net/api/intake"
  : null;
